<template>
  <div>
    <a-descriptions
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-7"
    >
      <a-descriptions-item label="状态">
        {{ productStopOrder.status }}
      </a-descriptions-item>

      <a-descriptions-item label="数据更新时间">
        {{ productStopOrder.updated_at }}
      </a-descriptions-item>
    </a-descriptions>

    <a-row>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions simiot-descriptions-max-7"
        >
          <a-descriptions-item label="套餐名称">
            {{ productStopOrder.agents_product_name }}
          </a-descriptions-item>

          <a-descriptions-item label="总费用(元)">
            {{ productStopOrder.total_fee | formatCurrency }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions simiot-descriptions-max-7"
        >
          <a-descriptions-item label="卡号总数">
            {{ productStopOrder.cards_count }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="simiot-descriptions simiot-descriptions-max-7"
        >
          <a-descriptions-item label="停机保号资费">
            {{ productStopOrder.stop_price }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>

    <search-sim-card-stop-order @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-button type="primary" @click="exportData">导出</a-button>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      @change="sortChange"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findSimCardStopOrders, exportSimCardStopOrders } from '@/api/agent_product_stop_order'
import SearchSimCardStopOrder from '@/views/agent_monthly_bills/stop/show/Search'
import Pagination from '@/components/Pagination'
import { formatCurrency } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'ShowAgentMonthlyBillOrder',
  components: {
    Pagination,
    SearchSimCardStopOrder
  },
  props: {
    productStopOrder: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'ICCID/SIMID',
          dataIndex: 'iccid',
          fixed: 'left',
          sorter: true,
          sortOrder: this.sort.sort_field === 'iccid' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'iccid' }
        },
        {
          title: '手机号码',
          dataIndex: 'phone_number'
        },
        {
          title: '停机保号资费(元)',
          dataIndex: 'stop_price',
          customRender: formatCurrency
        },
        {
          title: '总费用(元)',
          dataIndex: 'total_fee',
          customRender: formatCurrency,
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_fee' ? this.sort.sort_order : false
        }
      ]
    },
    productStopOrderId() {
      return parseInt(this.$route.params.stop_id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSimCardStopOrders(this.productStopOrderId, Object.assign({},
        this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }

        this.loading = false
      })
    },

    exportData() {
      exportSimCardStopOrders(this.productStopOrderId, this.query).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
